import UtilsService from './Utils';

export const Utils = UtilsService;

